import cn from 'clsx';

import { ScrollEventWrapper } from '@/components/common/ScrollEventWrapper';
import FaqAccordion from '@/components/landing/FaqAccordion';
import { FaqItem, LandingSectionProps } from '@/lib/constants/home';

const RefundFAQ = ({ sectionId, maxWidth }: LandingSectionProps) => {
  return (
    <ScrollEventWrapper sectionId={sectionId}>
      <div className={'flex w-full justify-center'}>
        <div
          className={cn('app-side-padding w-full py-[12em]', {
            ['max-w-screen-lg']: maxWidth === 'screen',
            ['max-w-[700px]']: maxWidth === '700'
          })}
        >
          <div className={'heading-3 mb-[1.25em] text-center'}>
            궁금해 할 내용을 <br />
            미리 모아 알려드려요.
          </div>
          {FAQ_ITEMS.map((item, index) => {
            const borderBottomClass = { 'border-b-[1px]': index < FAQ_ITEMS.length - 1 };
            return <FaqAccordion key={index} item={item} className={cn('border-b-[#E2E5EE]', borderBottomClass)} />;
          })}
        </div>
      </div>
    </ScrollEventWrapper>
  );
};

export default RefundFAQ;

const FAQ_ITEMS: FaqItem[] = [
  {
    title: '비즈넵 환급은 어떤 서비스인가요?',
    contents: (
      <>
        비즈넵 환급은 세무 자동화 전문 기업 지엔터프라이즈의 <span className={'font-bold'}>세금 환급 서비스</span>입니다. 비즈넵 환급은 납부한
        종합소득세(사업자)·양도소득세·법인세 중 아낄 수 있었던 세금을 찾아 ‘경정청구’를 도와드립니다. <br />
        <br />
        경정청구란 국세기본법 제45조 2항에 명시된 지난 5년간 더 낸 세금을 돌려받을 수 있는 제도입니다. 비즈넵 환급은 각 사용자별 200여 가지의 세액 공제 및 세액
        감면 항목들을 고도화된 AI 기술로 조회하며, 제휴 세무사가 조회 결과를 더블 체크해 누수 없는 세금 환급을 진행합니다.
      </>
    ),
    clickEvent: 'landing_bottom_faq-what'
  },
  {
    title: '환급은 어떻게 진행되나요?',
    contents: (
      <>
        비즈넵 환급은 아래와 같이 진행됩니다.
        <br />
        <br />
        예상 환급액 조회 → 환급 신청 → 제휴 세무사의 검토 → 경정청구 신고서 접수 → 환급금 입금(관할 세무서) → 이용료 결제
      </>
    ),
    clickEvent: 'landing_bottom_faq-how'
  },
  {
    title: '비즈넵 환급은 안전한가요?',
    contents: (
      <>
        비즈넵 환급은 세무 기술력을 인정받아 네이버와 네이버 파이낸셜이 함께 투자한 지엔터프라이즈가 만듭니다. 세무 전문가가 직접 개발하고 검증했기에 안심하고
        이용하셔도 됩니다.
        <br />
        <br />
        또한 비즈넵 환급은 모든 데이터를 산업 표준 AES-256로 암호화하고 있으며, 모든 트래픽은 TLS 1.2를 적용해 암호화된 상태로 안전하게 운영합니다.
      </>
    ),
    clickEvent: 'landing_bottom_faq-safety'
  },
  {
    title: '환급받은 이후에 세무 조사를 받을 수도 있나요?',
    contents: (
      <>
        경정청구와 세무조사는 무관하니 걱정하지 않으셔도 됩니다.
        <br />
        <br />
        경정청구는 납세자의 정당한 권리입니다. 과세관청은 경정청구 신청 항목에 대해서만 세금 환급 여부를 검토할 수 있습니다. 환급금은 과세관청이 환급을 결정한
        금액이며, 경정청구 항목을 가지고 세무조사 대상 여부를 판단할 수는 없습니다.
      </>
    ),
    clickEvent: 'landing_bottom_faq-after'
  },
  {
    title: '이용료가 부과되나요?',
    contents: (
      <>
        예상 환급액은 무료로 조회할 수 있습니다. 다만, 조회 후 실제 환급을 신청할 경우에는 소정의 이용료가 발생합니다. 이는 제휴 세무사의 신고 대리에 따라 제휴
        세무사에게 지급되는 이용료로, 실제 환급금을 입금받으신 후 신용카드로 결제할 수 있습니다.
      </>
    ),
    clickEvent: 'landing_bottom_faq-paid'
  }
];
